import React from 'react';

import { Space } from 'antd-v5';
import { MdError } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'scouting-ui/lib';

import { missingRelationshipSel } from '@modules/parentGuardian/duck/selectors';
import { setShowMissingRelationshipsModal } from '@modules/parentGuardian/duck/slice';
import {
  ConditionalRender,
  ProgramColors,
  ProgramLogo,
  S,
  UnitGenderPill,
} from '@shared/components';
import type { ParentUserOrganizationInfo } from '@user/types';

import styles from './RolePickerRole.less';
import RolePickerBaseRole, {
  type RolePickerBaseRoleProps,
} from './components/RolePickerBaseRole';

const RolePickerParentGuardianRole: React.FC<
  RolePickerBaseRoleProps & {
    org: ParentUserOrganizationInfo;
  }
> = ({ org, ...props }) => {
  const { connection, unitGender, organizationName, program } = org || {};
  const dispatch = useDispatch();
  const missingRelationships = useSelector(missingRelationshipSel);
  const showAlert = !!missingRelationships.find(
    item => item.personGuid === org.personGuid,
  );

  if (!connection) return null;

  return (
    <RolePickerBaseRole org={org} {...props}>
      <ProgramColors program={program}>
        <ProgramLogo program={program} className={styles.logo} />
      </ProgramColors>
      <div className={styles.description}>
        <Space align="center" size={0}>
          <S size="4">
            <FormattedMessage id="context.RolePickerRole.parentGuardian" />
          </S>
          <ConditionalRender value={showAlert}>
            <Button
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                dispatch(setShowMissingRelationshipsModal({ show: true }));
              }}
              className={styles.parentMissingRelationshipBtn}
              type="link"
              danger
              shape="circle"
              icon={<MdError />}
            />
          </ConditionalRender>
        </Space>
        <div className={styles.parentMisc}>
          <S size="5">{organizationName}</S>{' '}
          <UnitGenderPill gender={unitGender} colored splitFamilyLabel />
        </div>
        <S size="5">
          <FormattedMessage
            id="context.RolePickerRole.connection"
            values={{
              person: connection,
            }}
          />
        </S>
      </div>
    </RolePickerBaseRole>
  );
};

export default RolePickerParentGuardianRole;
